<template>
  <v-sheet 
    v-if="currentBanner.title"
    :class="['hero-bg', !isValidImage ? 'no-image' : '']"
    class="hero-bg mx-16 d-flex align-center justify-center mt-2" 
    min-height="235"
    :style="bannerStyle"
  >
    <v-container class="text-center my-4">
      <v-responsive max-width="70%" class="mx-auto">
        <h1 class="text-h1 white--text dropshadow lato-font" style="font-size: 3.7rem !important;">
          {{ currentBanner.title | uppercase }}
        </h1>
      </v-responsive>
    </v-container>
  </v-sheet>

  <v-sheet v-else>
    <v-container class="mb-1"></v-container>
  </v-sheet>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      currentBanner: 'microsite/currentBanner'
    }),
    ...mapState({
      meta: (state) => state.microsite.meta
    }),
    attributes() {
      return this.meta?.attributes || {}
    },
    isValidImage() {
      return this.currentBanner.banner && this.currentBanner.banner.length > 5 && !this.currentBanner.banner.endsWith('/0/')
    },
    bannerStyle() {
      return this.isValidImage
        ? { backgroundImage: `url(${this.currentBanner.banner})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : { backgroundColor: '#2d1e28' } // Change to your preferred solid background color
    }
  },
  methods: {
    orderPage() {
      window.location.href = '/order'
    },
    managePage() {
      window.location.href = '/manage-coverage'
    }
  }
}
</script>
<style scoped>
.hero-bg {
  position: relative;
  background-size: cover;
  background-position: left;
  margin: 0 auto; 
  border-radius: 10px; 
  overflow: hidden;
}

/* Dark overlay for background image */
.hero-bg::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(5, 30, 40, 0.3); /* Adjust transparency */
}

/* Hide overlay when there's no background image */
.hero-bg.no-image::before {
  display: none;
}

/* Optional: Add drop shadow for better text visibility */
.dropshadow {
  text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.3);
}

/* Button adjustments */
.rounded-btn {
  border-radius: 4px !important;
}
</style>